import {combineReducers} from '@reduxjs/toolkit';
import aircrafts from './aircrafts.slice';
import createAircraft from './create-aircraft.slice';
import updateAircraft from './update-aircraft.slice';

const reducer = combineReducers({
  aircrafts,
  createAircraft,
  updateAircraft
});

export default reducer;
